import React from "react";
import { withNamespaces } from "react-i18next";
import { Row, Col, Card, CardBody, Label } from "reactstrap";

const WelcomeComp = (props) => {
  const role = localStorage.getItem("role");
  const store = localStorage.getItem("store_name");
  const store_type = localStorage.getItem("store_type");
  const username = localStorage.getItem("name");

  return (
    <React.Fragment>
      <Card className="overflow-hidden shadow-sm">
        <div className="bg-soft-primary"  style={{minHeight:"99px"}}>
          <CardBody>
            <Row className="align-items-center">
              <Col xs="auto" className="pr-0">
                <i className="bx bx-user text-primary mr-2" style={{fontSize: '40px'}}></i>
              </Col>
              <Col>
                <div className="text-primary text-truncate">
                  <h5 className="text-primary mb-1">
                    {props.t("Welcome")}
                  </h5>
                  <div className="d-flex flex-column text-dark">
                    <span className="font-weight-normal mb-1">
                      {props.t(username)}
                    </span>

                    <span className="font-weight-bold mb-2">
                      {props.t(role)}
                    </span>

                    {(role === "Branch Supervisor" || 
                      role === "Sub Store Manager" || 
                      role === "Equipment Store Manager" || 
                      role === "Main Store Manager") && (
                      <div className="d-flex align-items-center text-muted">
                        <i className="bx bx-store mr-1"></i>
                        <span>
                          {store}
                          <span className="ml-1">({store_type})</span>
                        </span>
                      </div>
                    )}
                  </div>

                </div>
              </Col>
            </Row>
          </CardBody>
        </div>
      </Card>
    </React.Fragment>
  );
};

export default withNamespaces()(WelcomeComp);